import getReferenceAttachmentDisplayUrl from './getReferenceAttachmentDisplayUrl';
import getReferenceAttachmentPermissionString from './getReferenceAttachmentPermissionString';
import { AttachmentViewState } from 'owa-attachment-data';
import { AttachmentModel, ReferenceAttachmentModel } from 'owa-attachment-model-store';
import { isFeatureEnabled } from 'owa-feature-flags';
import { numberToByteQuantifiedStringConverter } from 'owa-file';
import ReferenceAttachment from 'owa-service/lib/contract/ReferenceAttachment';
import { OwaDate } from 'owa-datetime';

export function getFirstLineTitle(
    attachmentViewState: AttachmentViewState,
    attachment: AttachmentModel
): string | undefined {
    let title: string | undefined = attachment.model.Name;
    if (attachmentViewState.isCloudy) {
        const referenceAttachmentModel: ReferenceAttachmentModel = attachment as ReferenceAttachmentModel;

        let url: string;
        if (isFeatureEnabled('doc-unwrap-safelinks')) {
            url = referenceAttachmentModel.originalUrl;
        } else {
            url = referenceAttachmentModel.openUrl;
        }

        if (!url) {
            url = (attachment.model as ReferenceAttachment).AttachLongPathName;
        }

        if (url) {
            title += '\n \n' + url;
        }
    }
    return title;
}

export interface TextAndTitle {
    text: string | null;
    title: string | null;
}
export function getSecondLineTextAndTitle(
    attachmentViewState: AttachmentViewState,
    attachment: AttachmentModel
): TextAndTitle {
    if (attachmentViewState.isCloudy) {
        const referenceAttachment = attachment.model as ReferenceAttachment;
        if (attachmentViewState.isReadOnly) {
            return {
                text: getReferenceAttachmentDisplayUrl(
                    (attachment as ReferenceAttachmentModel).openUrl,
                    referenceAttachment.AttachLongPathName || null
                ),
                title: null,
            };
        }
        const expirationDate: OwaDate | null = attachment.info?.sharingInfo?.expirationDate;

        const permissionString = getReferenceAttachmentPermissionString(
            referenceAttachment.PermissionType,
            referenceAttachment.ProviderType,
            expirationDate,
            attachmentViewState.isPlaceholderAttachment
        );
        return { text: permissionString, title: permissionString };
    }
    const text: string | null =
        attachment.model.Size > 0
            ? numberToByteQuantifiedStringConverter(attachment.model.Size)
            : null; // Some clients may not set the size property during attachment creation, then just don't display the size info.
    return {
        text: text,
        title: text,
    };
}
